<template>
  <div class="company-view">
    <SidebarToggleView />
    <span class="display-2" v-if="company">{{ company.name }}</span>
    <span style="float:right">
      <v-btn outlined class="v-accent v-raised" color="primary" @click="onShowPrintDialog">
        <v-icon class="mr-2">description</v-icon>Dokument erstellen
      </v-btn>
    </span>
    <span style="float:right" class="mr-2" color="primary" @click="onCreateFromTemplate">
      <v-btn outlined color="primary">
        <v-icon class="mr-2">post_add</v-icon>VVT-Vorlage importieren
      </v-btn>
    </span>
    <div style="margin:50px"></div>
    <div v-if="loading">Lade...</div>
    <div v-else-if="errors.length > 0">Fehler beim Laden</div>
    <div v-else-if="company">
      <table id="companyTable" >
        <tr>
          <td><i>Unternehmen</i></td>
          <td>
            <strong>{{ displayCompany.fullname }}</strong>
          </td>
        </tr>
        <tr></tr>
        <tr>
          <td><i>Adresse</i></td>
          <td>{{ displayCompany.streetAndNo }}</td>
        </tr>
        <tr>
          <td></td>
          <td>{{ displayCompany.zipCity }}</td>
        </tr>
        <tr>
          <td></td>
          <td>{{ displayCompany.country }}</td>
        </tr>
        <tr></tr>
        <tr>
          <td><i>Verantwortlicher</i></td>
          <td>{{ displayCompany.responsibleName }}</td>
        </tr>
        <tr>
          <td><i>Rolle des Verantwortlichen</i></td>
          <td>{{ displayCompany.responsibleRole }}</td>
        </tr>
      </table>
      <br /><br />
      <v-btn outlined class="v-accent v-raised" color="primary" @click="onShowCompanyEditDialog">
        <v-icon class="mr-2">mdi-pencil</v-icon>Bearbeiten
      </v-btn>
      <br /><br />
      <div v-if="company.createdAt">
        Erstellt: {{ company.createdAt | moment("DD.MM.YYYY") }} um {{ company.createdAt | moment("HH.mm") }} Uhr
      </div>
      <div v-if="company.updatedAt">
        Geändert: {{ company.updatedAt | moment("DD.MM.YYYY") }} um {{ company.updatedAt | moment("HH.mm") }} Uhr
      </div>
      <br /><br />
      <v-dialog v-model="showDeleteImpossiblePopup" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Löschen fehlgeschlagen</v-card-title>
          <v-card-text
            >Unternehmen kann erst gelöscht werden, wenn die zugehörigen Verfahren gelöscht wurden.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="showDeleteImpossiblePopup = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="ma-2" style="position:absolute;bottom:0;width:95%">
        <v-card flat dark class="mt-2">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Dieses Unternehmen löschen
                </v-list-item-title>
                <v-list-item-subtitle>
                  Dieses Unternehmen dauerhaft und unwiderbringlich löschen
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn outlined color="error" v-on:click="onShowDeleteCompanyDialog()">
                  löschen
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </div>
      <ExportView
        v-if="user_info"
        :company="company"
        :showThis="showPrintDialog"
        v-on:discard="showPrintDialog = false"
      >
      </ExportView>
      <CompanyEditView :company_id="company.id" :showThis="showCompanyEditDialog" v-on:discard="onCompanyEdit">
      </CompanyEditView>
      <CompanyDeleteView
        :company_id="company.id"
        :showThis="showDeleteCompanyDialog"
        v-on:discard="showDeleteCompanyDialog = false"
        v-on:didDelete="onDeleted()"
      >
      </CompanyDeleteView>
      <ActionImpossibleView
        actionType="PDF_PRINT"
        :showThis="show_pdf_print_disallowed"
        v-on:discard="show_pdf_print_disallowed = false"
      >
      </ActionImpossibleView>
      <ActionImpossibleView
        actionType="CREATE"
        :showThis="show_company_create_disallowed"
        v-on:discard="show_company_create_disallowed = false"
      >
      </ActionImpossibleView>
      <ActionImpossibleView
        actionType="UPDATE"
        :showThis="show_company_update_disallowed"
        v-on:discard="show_company_update_disallowed = false"
      >
      </ActionImpossibleView>
    </div>
  </div>
</template>

<script>
const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes (limit: 500){
        items{
            id
        }
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
const updateCompany = `mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes (limit: 500){
        items{
            id
        }
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;

import ExportView from "./ExportView";
import CompanyDeleteView from "./CompanyDeleteView";
import ActionImpossibleView from "./ActionImpossibleView";
import SidebarToggleView from "./SidebarToggleView";
import CompanyEditView from "./CompanyEditView";

const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

export default {
  name: "CompanyView",
  components: {
    ExportView,
    CompanyDeleteView,
    ActionImpossibleView,
    SidebarToggleView,
    CompanyEditView,
  },
  watch: {
    "$route.params.id"(newId, oldId) {
      this.initRoute();
    },
  },
  computed: {
    getCompanyQuery() {
      return this.$Amplify.graphqlOperation(getCompany, { id: this.company.id });
    },
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
    allowed_templates() {
      var user_info = this.$store.state.originalStore.user_info;
      if (!this.user_info) {
        return [];
      }
      var product_id = this.user_info.attributes["custom:active_product_id"];
      var templates = products[product_id].usage.allowed_templates;

      var add_templates = this.user_info.attributes["custom:add_templates"];
      if (add_templates && add_templates.length > 0) {
        add_templates = add_templates.split(",").map((e) => e.trim());
        templates = templates.concat(add_templates);
      }

      return templates;
    },
    displayCompany: function() {
      return {
        streetAndNo: `${this.company.address_street ? this.company.address_street : ""} ${
          this.company.address_street_no ? this.company.address_street_no : ""
        }`,
        zipCity: `${this.company.address_zip ? this.company.address_zip : ""} ${
          this.company.address_city ? this.company.address_city : ""
        }`,
        country: this.company.address_country ? this.company.address_country : "",
        responsibleName: this.company.responsible_name ? this.company.responsible_name : "-",
        responsibleRole: this.company.responsible_role ? this.company.responsible_role : "-",
        fullname: this.company.fullname ? this.company.fullname : this.company.name,
      };
    },
  },
  mounted() {
    this.initRoute();
    this.$store.dispatch("getCompanies");
  },
  methods: {
    load() {
      this.loading = true;
      this.$Amplify.API.graphql(this.getCompanyQuery).then((response) => this.onLoaded(response));
    },
    onLoaded(response) {
      this.company = response.data.getCompany;
      this.displayCompany;
      this.$store.commit("SET_active_company", { company: this.company });
      this.loading = false;
    },
    can_print_pdf() {
      var product_id = this.user_info.attributes["custom:active_product_id"];
      var product = products[product_id];
      var num_companies = this.$store.state.copyProcesses.companies.length;
      var num_processes = this.company.processes.items.length;
      return num_companies <= product.usage.max_companies && num_processes <= product.usage.max_processes;
    },
    can_update_company() {
      var product_id = this.user_info.attributes["custom:active_product_id"];
      var product = products[product_id];
      var num_companies = this.$store.state.copyProcesses.companies.length;
      return num_companies <= product.usage.max_companies;
    },
    onDeleted() {
      this.$router.push({ path: "/app" });
    },
    onShowPrintDialog() {
      this.showPrintDialog = true;
      //if (this.can_print_pdf()){
      //  this.showPrintDialog = true
      //}else{
      //  this.show_pdf_print_disallowed = true
      //}
    },
    onShowDeleteCompanyDialog() {
      this.showDeleteCompanyDialog = true;
    },
    onShowCompanyEditDialog() {
      this.showCompanyEditDialog = true;
    },
    initRoute() {
      this.company = { id: this.$route.params.id };
      this.$eventHub.emit("sync-status-neutral");
      this.load();
    },
    onImportFromFile() {
      this.$router.push({ path: "/app/company/" + this.$route.params.id + "/upload" });
    },
    can_create_from_template(tpl_name) {
      return this.allowed_templates.includes(tpl_name);
    },
    onCreateFromTemplate() {
      this.$router.push({ path: "/app/company/" + this.$route.params.id + "/template/"});
    },
    onCompanyEdit() {
      this.load();
      this.showCompanyEditDialog = false;
    },
  },
  data: () => ({
    company: null,
    loading: true,
    errors: [],
    showDeleteImpossiblePopup: false,
    showPrintDialog: false,
    showDeleteCompanyDialog: false,
    showCompanyEditDialog: false,
    show_company_create_disallowed: false,
    show_company_update_disallowed: false,
    show_pdf_print_disallowed: false,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#companyTable {
  table-layout: auto;
  border-spacing: 10px;
}
</style>
